import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '33.33%',
    color: '#fff',
    margin: 'auto'
  },
  image: {
    objectFit: 'cover',
    clipPath: 'inset( 0 0 50% 0)',
    marginTop: '30px',
  },
  map: {
    position: 'absolute',
    top: '0',
    left: '0',
  },
  visitor: {
    color: 'rgb(204, 133, 0)',
    fontWeight: '700',
    fontSize: '24px'
  }
});
const SocialMedia = () => {
  const classes = useStyles();
  const handleRedirect = (site) => {
    switch (site) {
      case 'facebook':
        console.log('Redirect to Facebook');
        break;
      case 'twitter':
        console.log('Redirect to Twitter');
        break;
      case 'National Portal Of India':
        console.log('Redirect to Youtube');
        break;
      case 'Uttar Pradesh State Portal':
        console.log('Redirect to Instagram');
        break;
      default:
        break;
    }
  };

  return (
    <div className={classes.container}>
      <img src="https://i.imgur.com/ks7yCiC.png" className={classes.image} useMap="#socialMap" alt="Social Icons"  />
      <map name="socialMap" className={classes.map}>
        <area shape="rect" coords="0,0,50,50" alt="Facebook" onClick={() => handleRedirect('facebook')} />
        <area shape="rect" coords="50,0,100,50" alt="Twitter" onClick={() => handleRedirect('twitter')} />
        <area shape="rect" coords="0,50,50,100" alt="National Portal Of India" onClick={() => handleRedirect('National Portal Of India')} />
        <area shape="rect" coords="50,50,100,100" alt="Uttar Pradesh State Portal" onClick={() => handleRedirect('Uttar Pradesh State Portal')} />
      </map>
      <p>Total Visitors: <span className={classes.visitor}>1420875</span></p>
    </div>
  );
};

export default SocialMedia;
